/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AzureStorageAccount } from '../models/AzureStorageAccount';

export class AzureStorageAccounts {
  'storageAccounts': Array<AzureStorageAccount>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "storageAccounts",
      "baseName": "storageAccounts",
      "type": "Array<AzureStorageAccount>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureStorageAccounts.attributeTypeMap;
  }

  public constructor() {
  }
}

